import React, { useEffect, useRef, useState } from "react";

import {
  Box,
  Text,
  Divider,
  Flex,
  Tooltip,
  Icon,
  Spinner,
} from "@chakra-ui/react";
import { IoHelpCircle } from "react-icons/io5";
import { RiFileExcel2Line } from "react-icons/ri";
import { PrintButtonPendencias } from "../../../../components/PrintButtonPendencias";
import {
  criancaFunc,
  Permission,
  servicos,
} from "../../../../../helpers/Funcionalidades";
import { useAuthProvider } from "../../../../../Context/AuthProvider";
import { useAppContext } from "../../../../../Context/MessageContextProvider";
import { PrintButtonPendenciasServico } from "../../../../components/PrintButtonPendenciasServico";
import ServicoAcolhimentoService from "../../../../../main/services/ServicoAcolhimentoService";
import CriancaService from "../../../../../main/services/CriancaService";

const Group = ({
  title,
  children,
  mt,
  bgColor,
  py,
  mtDivider,
  dividerFalse,
  marginTitle,
  position,
  regularidade,
  opcoes,
  menuComponent,
  showMenuItemsAtribuicao,
  border,
  scrollToField,
  tooltipText,
  downloadPendencias,
  idCrianca,
  servico,
  idServico,
}) => {
  const { roleKeycloack, user } = useAuthProvider();
  const { idPJ, crianca, servicoData } = useAppContext();
  const [loading, setLoading] = useState(false);

  const anexoRef = useRef(null);
  useEffect(() => {
    scrollToField && scrollToField(anexoRef);
  }, [scrollToField]);

  const getExportarExecel = async (idServico) => {
    let res;
    try {
      setLoading(true);

      res = servico
        ? await ServicoAcolhimentoService.getPendenciaServicoDownload(idServico)
        : await CriancaService.getPendenciaDownload(idCrianca);
      const downloadUrl = res.config.url;
      window.open(downloadUrl, "_blank");
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      position={position ? position : ""}
      mt={mt ? mt : "15px"}
      display="block"
      px="18px"
      py={py ? py : "25px"}
      pt={!title ? "10px" : "25px"}
      pb={marginTitle && "5px"}
      borderRadius="10px"
      w={"100%"}
      bgColor={bgColor ? bgColor : "#FFF"}
      border={border ? border : ""}
      ref={anexoRef}
    >
      <Text
        fontWeight={700}
        fontSize="16px"
        display={opcoes && "flex"}
        justifyContent={opcoes && "space-between"}
        lineHeight="21.6px"
        color={`${regularidade ? "#169499" : "#169499"}`}
      >
        <Flex alignItems="center" gap={2}>
          {title.toUpperCase()}{" "}
          {tooltipText && (
            <Tooltip textAlign={"justify"} label={tooltipText}>
              <Box h={"20px"}>
                <Icon
                  aria-label="Aviso de pendente"
                  color="#6B6C71"
                  as={IoHelpCircle}
                  boxSize="14px"
                />
              </Box>
            </Tooltip>
          )}
        </Flex>
        {opcoes && showMenuItemsAtribuicao && (
          <Box>
            <Box position="relative" mr={"20px"}>
              {!downloadPendencias ? (
                <>
                  <Text as="b" color="black" fontSize={"md"}>
                    Opções
                  </Text>
                  {menuComponent}{" "}
                </>
              ) : (
                <Flex alignItems="center" gap={4}>
                  <Permission
                    roleKeycloack={roleKeycloack}
                    func={
                      servico
                        ? servicos.pendenciasServExportar
                        : criancaFunc.pendenciasExportar
                    }
                    user={user}
                    id={idPJ}
                    visualizar={true}
                  >
                    {loading ? (
                      <Spinner size="sm" />
                    ) : (
                      <Flex
                        alignItems="center"
                        gap={2}
                        cursor="pointer"
                        onClick={() => !loading && getExportarExecel(idCrianca)}
                      >
                        <Flex bg="#006400" rounded="full" p={1}>
                          <RiFileExcel2Line color="white" />
                        </Flex>

                        <Text as="b" color="#006400" fontSize={"md"}>
                          Exportar em Excel
                        </Text>
                      </Flex>
                    )}
                  </Permission>

                  <Permission
                    roleKeycloack={roleKeycloack}
                    func={
                      servico
                        ? servicos.pendenciasServImprimir
                        : criancaFunc.pendenciasImprimir
                    }
                    user={user}
                    id={idPJ}
                    visualizar={true}
                  >
                    {servico ? (
                      <PrintButtonPendenciasServico
                        idServico={idServico}
                        dados={servicoData}
                        user={user}
                        servico={true}
                      />
                    ) : (
                      <PrintButtonPendencias
                        idCrianca={idCrianca}
                        dados={crianca}
                        user={user}
                      />
                    )}
                  </Permission>
                </Flex>
              )}
            </Box>
          </Box>
        )}
      </Text>

      {!dividerFalse && (
        <Divider
          mt={mtDivider ? mtDivider : "10px"}
          orientation="horizontal"
          borderColor={"#DDEBEA"}
        />
      )}
      {children}
    </Box>
  );
};

export default Group;
